import { Grid, styled } from "@mui/material";
import { PaymentDetailsBlock } from "../orders/order-popup/payment-details/styled";

export const CalculatePageContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: 'flex-start',
    gap: '1rem',
    paddingTop: '40px',
    marginBottom: '125px',
}));

export const CalculateContainer = styled(Grid)(() => ({
    padding: '1rem'
}));

export const VolumeContainer = styled("div")(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    gap: '0.25rem'
}));

export const PaymentInfoDetailsBlock = styled(PaymentDetailsBlock)(({ theme }) => ({
    borderRadius: '0.5rem',
    backgroundColor: theme.barekam.background
}));
